<div class="container border rounded-2 p-4">
  <h3 class="text-center">User Profile</h3>
  <form [formGroup]="myForm" (ngSubmit)="onSubmit(myForm)">


    <b>Role</b>
    <div class="col-5">
      <select formControlName="userRole" required  class="form-select">
        @for (r of profile; track r) {
          <option [value]="r.roleId">
            {{r.name}}
          </option>
        }
      </select>
    </div>
    <br>

      <button class="btn btn-danger">Switch Role</button>

    </form>

  </div>